import apiTrainerResults from '@/api/trainer-result'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  deleteTrainerResultStart:
    '[delete trainer result] Delete trainer result start',
  deleteTrainerResultSuccess:
    '[delete trainer result] Delete trainer result success',
  deleteTrainerResultFailure:
    '[delete trainer result] Delete trainer result failure',
}

export const actionTypes = {
  deleteTrainerResult: '[delete trainer result] Delete trainer result',
}

const mutations = {
  [mutationTypes.deleteTrainerResultStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteTrainerResultSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteTrainerResultFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.deleteTrainerResult](context, {id}) {
    context.commit(mutationTypes.deleteTrainerResultStart)
    return new Promise((resolve) => {
      apiTrainerResults
        .deleteTrainerResult(id)
        .then((response) => {
          context.commit(mutationTypes.deleteTrainerResultSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.deleteTrainerResultFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
